var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Stack } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppSelector } from '../../../store/hooks';
import { paymentTermListAPI, paymentTypeListAPI } from '../services/apiCall';
import { ContractInvoiceKeys } from '../services/entity';
var PaymentReceivePopup = function (_ref) {
    var _crud$ContractInvoice, _crud$ContractInvoice2, _crud$ContractInvoice3, _crud$ContractInvoice4, _crud$ContractInvoice5, _crud$ContractInvoice6, _crud$ContractInvoice7, _crud$ContractInvoice8;
    var onClose = _ref.onClose, data = _ref.data, PaymentTypeId = _ref.PaymentTypeId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var CashMode = [{
            type: FormItemTypes.ContainerItem,
            name: 'cashMode',
            label: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    columnSize: 12,
                    borderRadius: '8px',
                    sx: {
                        border: "1px solid",
                        borderColor: 'secondary.200',
                        bgcolor: 'secondary.50'
                    },
                    padding: '12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Customer name',
                            value: "".concat((_crud$ContractInvoice = (_crud$ContractInvoice2 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice2 === void 0 || (_crud$ContractInvoice2 = _crud$ContractInvoice2.data) === null || _crud$ContractInvoice2 === void 0 || (_crud$ContractInvoice2 = _crud$ContractInvoice2.Person) === null || _crud$ContractInvoice2 === void 0 ? void 0 : _crud$ContractInvoice2.GivenName) !== null && _crud$ContractInvoice !== void 0 ? _crud$ContractInvoice : '-', " ").concat((_crud$ContractInvoice3 = (_crud$ContractInvoice4 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice4 === void 0 || (_crud$ContractInvoice4 = _crud$ContractInvoice4.data) === null || _crud$ContractInvoice4 === void 0 || (_crud$ContractInvoice4 = _crud$ContractInvoice4.Person) === null || _crud$ContractInvoice4 === void 0 ? void 0 : _crud$ContractInvoice4.FamilyName) !== null && _crud$ContractInvoice3 !== void 0 ? _crud$ContractInvoice3 : ' '),
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'GrandTotal',
                            label: 'Net payable amount',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 0
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    // padding: '2px 12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'PaymentTypeName',
                            label: 'Payment method:',
                            value: null,
                            fontWeight: 'strong',
                            fontSize: 'xl',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'PaymentTypeId',
                            getListData: paymentTypeListAPI,
                            apiKey: ContractInvoiceKeys.PaymentTypeListKey,
                            displayExpr: 'Name',
                            valueExpr: 'PaymentTypeId',
                            placeholder: 'Cash / Online',
                            columnSize: 6
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    // padding: '2px 12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'referanceno',
                            label: 'Reference No.',
                            fontWeight: 'strong',
                            fontSize: '14px',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'refNo',
                            label: '',
                            value: '',
                            placeholder: 'Reference No',
                            columnSize: 7
                        }]
                }]
        }];
    var CreditMode = [{
            type: FormItemTypes.ContainerItem,
            name: 'creditMode',
            label: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    columnSize: 12,
                    borderRadius: '8px',
                    sx: {
                        border: "1px solid",
                        borderColor: 'secondary.200',
                        bgcolor: 'secondary.50'
                    },
                    padding: '12px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Customer name',
                            value: "".concat((_crud$ContractInvoice5 = (_crud$ContractInvoice6 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice6 === void 0 || (_crud$ContractInvoice6 = _crud$ContractInvoice6.data) === null || _crud$ContractInvoice6 === void 0 || (_crud$ContractInvoice6 = _crud$ContractInvoice6.Person) === null || _crud$ContractInvoice6 === void 0 ? void 0 : _crud$ContractInvoice6.GivenName) !== null && _crud$ContractInvoice5 !== void 0 ? _crud$ContractInvoice5 : '-', " ").concat((_crud$ContractInvoice7 = (_crud$ContractInvoice8 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice8 === void 0 || (_crud$ContractInvoice8 = _crud$ContractInvoice8.data) === null || _crud$ContractInvoice8 === void 0 || (_crud$ContractInvoice8 = _crud$ContractInvoice8.Person) === null || _crud$ContractInvoice8 === void 0 ? void 0 : _crud$ContractInvoice8.FamilyName) !== null && _crud$ContractInvoice7 !== void 0 ? _crud$ContractInvoice7 : ' '),
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'GrandTotal',
                            label: 'Net payable amount',
                            value: null,
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'strong',
                            fontSize: 'lg',
                            columnSize: 0
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '0',
                            label: 'Credit limit',
                            value: null,
                            fontWeight: 'strong',
                            fontSize: 'xl',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreditLimit',
                            label: '',
                            value: 0,
                            columnSize: 0,
                            color: 'secondary.500',
                            labelTypographyProps: {
                                fontWeight: "medium",
                                color: 'secondary.900'
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'outstandingBalance',
                            label: 'Outstanding balance ',
                            fontWeight: 'strong',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'outstandingBalance',
                            label: '',
                            value: 0,
                            columnSize: 0,
                            color: 'secondary.500',
                            labelTypographyProps: {
                                fontWeight: "medium",
                                color: 'secondary.900'
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '4px',
                    alignItems: 'center',
                    columnSize: 12,
                    borderRadius: '8px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Available limit ',
                            fontWeight: 'strong',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'availableLimit',
                            label: '',
                            value: 0,
                            columnSize: 0,
                            color: 'secondary.500',
                            labelTypographyProps: {
                                fontWeight: "medium",
                                color: 'secondary.900'
                            }
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PaymentTermId',
                    label: 'Payment term',
                    placeholder: 'Select',
                    getListData: paymentTermListAPI,
                    apiKey: ContractInvoiceKeys.PaymentTermListKey,
                    valueExpr: "PaymentTermId",
                    displayExpr: "Name",
                    labelTypographyProps: {
                        fontWeight: "medium"
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "PaymentDueDate",
                    label: "Payment due date ",
                    value: null,
                    placeholder: "Select date",
                    columnSize: 12,
                    disablePast: true
                }]
        }];
    var tabs = [(data === null || data === void 0 ? void 0 : data.PaymentModeName) == 'Cash' ? {
            id: 'cash',
            label: 'Cash Mode',
            elements: CashMode
        } : {
            id: 'credit',
            label: 'Credit Mode',
            elements: CreditMode
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'Header',
            value: null,
            label: '',
            display: 'flex',
            spacing: 0,
            columnSize: 12,
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Payment receive',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    sx: {
                        mx: -2
                    }
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Stepper',
            label: '',
            value: null,
            tabs: tabs,
            valueExpr: 'id',
            displayExpr: 'label',
            columnSize: 12
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.Button,
            name: 'Discard',
            children: 'Discard',
            columnSize: 6,
            fullWidth: true,
            color: 'secondary',
            variant: 'outlined',
            size: 'medium',
            onClick: function () {
                onClose();
            }
        }, {
            type: FormItemTypes.Button,
            name: 'save',
            children: 'Save',
            columnSize: 6,
            fullWidth: true,
            variant: 'contained',
            size: 'medium',
            onClick: function () { return 'submit'; }
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            p: 3
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            borderRadius: '50px'
        },
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        updateFormAPI: function (_ref2) { return __awaiter(void 0, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                request = _ref2.request;
                onClose(request);
                return [2 /*return*/, {
                        success: true
                    }];
            });
        }); }
    }));
};
export default PaymentReceivePopup;
